import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"position-absolute bg-white font-12 px-1 ml-2"},[_vm._v(_vm._s(_vm.legenda))]),_c(VDivider),_c('div',{staticClass:"position_absolute"},[_vm._t("lado-direito")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }